import React, { useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { Avatar, Badge, CircularProgress } from '@mui/material';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import { toLower, upperFirst } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import '../styles/compte.css';
import Navigation from '../components/Navigation';
import { ProfileDetailSkeleton } from '../components/skeletons';
import {
  categories,
  chatSelected,
  couleurTheme,
  formatTimeTo24h,
  formatName,
  formatFonction,
} from './fonctions';
import {
  accepterDemandeRedux,
  chatSelect,
  contactsRedux,
  demandesRedux,
  envoyerDemandeRedux,
  invitationsRedux,
  refreshToken,
  refuserDemandeRedux,
} from '../redux/profilService';
import {
  partenaireSelectRedux,
  participantSelectRedux,
  programmeSelectRedux,
  participantsReduxPage,
} from '../redux/evenementsServices';
import ErrorPopup from '../components/ErrorPopup';
import Chemin from '../components/Chemin';
import { useEffect } from 'react';
import { styled } from '@mui/material';
import textConnect from '../textConnect.json';
import { PoliceDefaut } from '../helpers/contants';
import { capture } from '../services/analytics';
import DetailNavigation from '../components/DetailNavigation';
import {
  setParticipantsNavigation,
  updateCurrentParticipantIndex,
  setPrefetchedParticipant,
  clearPrefetchedParticipants,
  addParticipants,
} from '../redux/evenementsSlice';

const CompteParticipant = () => {
  const param = useParams();

  const profilParticipant = useSelector(state => state.evenements.participantSelect);
  // const categorieParticipant = param.contact === '0' ? listeParticipants.length ? listeParticipants.filter((item) => { return item.id === profilParticipant.id })[0].profil : '' : ''
  const categorieParticipant =
    param.contact === '0'
      ? profilParticipant.profil === undefined
        ? ''
        : profilParticipant.profil
      : '';
  const evenementSelected = useSelector(state => state.evenements.evenementSelect);

  const monProfil = useSelector(state => state.profil.profil);
  const accessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);

  // Navigation context
  const participantsNavigationIds = useSelector(
    state => state.evenements.participantsNavigationIds || []
  );
  const currentParticipantIndex = useSelector(
    state => state.evenements.currentParticipantIndex ?? -1
  );
  const prefetchedParticipants = useSelector(
    state => state.evenements.prefetchedParticipants || {}
  );
  const participantsNavigationContext = useSelector(
    state =>
      state.evenements.participantsNavigationContext || {
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        pageSize: 20,
      }
  );

  // const mesContacts = useSelector(state => state.profil.contacts)

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  function reseauSociaux(reseaux) {
    var tabRetour = [];

    for (let index = 0; index < reseaux.length; index++) {
      if (reseaux[index].nom === 'link') {
        tabRetour.push({
          logo: pictos.linkedin_icone,
          url: reseaux[index].url,
        });
      }
      if (reseaux[index].nom === 'twi') {
        tabRetour.push({ logo: pictos.twitter_icone, url: reseaux[index].url });
      }
    }

    return tabRetour;
  }

  const [chat, setChat] = useState({});
  const [contactChat, setContactChat] = useState([]);

  const dispatch = useDispatch();
  const navigationPage = useNavigate();

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');
  const [isNavigating, setIsNavigating] = useState(false);

  const handleEnvoiDemande = () => {
    setCircle2(true);
    envoyerDemandeRedux(accessToken, selectProfil, evenementSelected.id)
      .then(reponse => {
        capture('contact_request_sent_web', { target_participant_id: selectProfil });
        setPending(true);
        setCircle2(false);
        setOpenEnvoyerDemande(false);

        // participantsRedux(accessToken, dispatch, evenementSelected.id)
      })
      .catch(erreur => {
        setCircle2(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });

              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });

              console.log('token refresh...');
              handleEnvoiDemande();
            });
          }
        }
      });
  };
  const closeErrorHandle = () => {
    setOpenError(false);
  };
  const [circle, setCircle] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const showLoading = useDelayedLoading(loading, 500);

  const programSelect = (token, id) => {
    setLoading(true);
    programmeSelectRedux(token, id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addProgrammeSelect',
          payload: reponse.data,
        });
        // window.open('/programmeDetail', '_top')
        navigationPage('/programme/' + id + '/0');
        setLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });

              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });

              console.log('token refresh...');
              programSelect(token, id);
            });
          }
        }
      });
  };
  const partenaireSelect = async id => {
    setLoading(true);

    // partenairesRedux(accessToken, evenementSelected.id).then((reponse) => {
    //     // console.log(reponse.data.filter(item => item.id_organisation === id))
    //     if (reponse.data.filter(item => item.id_organisation === id).length === 1) {
    partenaireSelectRedux(accessToken, evenementSelected.id, id)
      .then(response => {
        dispatch({
          type: 'evenements/addExposantSelect',
          payload: response.data,
        });
        navigationPage(`/partenaire/${id}/0`);
        window.scrollTo(0, 0);
        setLoading(false);
      })

      // }
      //     else {
      //         setMsgError("L'organisation ne participe pas dans cet événement")
      //         setOpenError(true)
      //         setLoading(false)
      //     }
      // })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });

              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });

              console.log('token refresh...');
              partenaireSelect(id);
            });
          }
        }
      });

    // dispatch(
    //     {
    //         type: 'evenements/addExposantSelect',
    //         payload: contenu
    //     }
    // );

    // navigationPage(`/partenaire/${id}`)
    // window.scrollTo(0, 0)
  };
  const location = useLocation();
  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  breadcrumbs_temp.push({
    url: param.contact === '0' ? '/participants' : '/contacts',
    nom: param.contact === '0' ? 'Participants' : 'Contacts',
  });
  if (profilParticipant.user) {
    breadcrumbs_temp.push({
      url: location.pathname,
      nom: formatName(profilParticipant.user.prenom, profilParticipant.user.nom),
    });
  }

  useEffect(() => {
    const participantId = param.idparticipant || profilParticipant?.id;
    if (!participantId) return;
    capture('participant_profile_viewed', { participant_id: participantId });
    const eventId = evenementSelected?.id ?? '';
    participantSelectRedux(accessToken, participantId, eventId)
      .then(reponse => {
        dispatch({
          type: 'evenements/addParticipantSelect',
          payload: reponse.data,
        });
        setLoading(false);
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });

              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });

              console.log('token refresh...');
            });
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param.idparticipant]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (profilParticipant.user) {
      dispatch({
        type: 'Profil/addChemin',
        payload: breadcrumbs_temp,
      });
    }
  }, [profilParticipant]);

  useEffect(() => {
    if (!profilParticipant.user) {
      return;
    }
    contactsRedux(accessToken)
      .then(response => {
        setContactChat(
          response.data.filter(item => {
            return item.id === profilParticipant.id;
          })
        );
        setChat(
          chatSelected(
            profilParticipant.user.nom,
            profilParticipant.user.prenom,
            profilParticipant.fonction,
            profilParticipant.conversation.id,
            profilParticipant.photo_path,
            profilParticipant.organisation.nom,
            profilParticipant.organisation.logo,
            profilParticipant.from_structure
          )
        );
        // setLoading(false)
      })
      .catch(erreur => {
        setLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });

              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });

              console.log('token refresh...');
            });
          }
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profilParticipant.user]);
  const [pending, setPending] = useState(false);
  const [openEnvoyerDemande, setOpenEnvoyerDemande] = useState(false);
  const [selectProfil, setSelectProfil] = useState('');
  const [circle2, setCircle2] = useState(false);
  const ouvrirEnvoyer = id => {
    setSelectProfil(id);
    setOpenEnvoyerDemande(true);
  };

  const [acceptLoading, setAcceptLoading] = useState(false);
  const [refuseLoading, setRefuseLoading] = useState(false);
  const handleAcceptInvitation = demandeId => {
    setAcceptLoading(true);
    accepterDemandeRedux(accessToken, demandeId)
      .then(() => {
        contactsRedux(accessToken).then(reponse => {
          dispatch({ type: 'Profil/addContacts', payload: reponse.data });
          demandesRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addDemandes', payload: reponse.data });
          });
          invitationsRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addInvitations', payload: reponse.data });
          });
        });
        // Refresh participant detail to update status
        participantSelectRedux(accessToken, profilParticipant.id, evenementSelected.id)
          .then(reponse => {
            dispatch({ type: 'evenements/addParticipantSelect', payload: reponse.data });
            setAcceptLoading(false);
          })
          .catch(() => setAcceptLoading(false));
      })
      .catch(erreur => {
        setAcceptLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
              dispatch({ type: 'user/addAccess', payload: reponse.data.access });
              handleAcceptInvitation(demandeId);
            });
          }
        }
      });
  };
  const handleRefuseInvitation = demandeId => {
    setRefuseLoading(true);
    refuserDemandeRedux(accessToken, demandeId)
      .then(() => {
        contactsRedux(accessToken).then(reponse => {
          dispatch({ type: 'Profil/addContacts', payload: reponse.data });
          demandesRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addDemandes', payload: reponse.data });
          });
          invitationsRedux(accessToken).then(reponse => {
            dispatch({ type: 'Profil/addInvitations', payload: reponse.data });
          });
        });
        // Refresh participant detail to update status
        participantSelectRedux(accessToken, profilParticipant.id, evenementSelected.id)
          .then(reponse => {
            dispatch({ type: 'evenements/addParticipantSelect', payload: reponse.data });
            setRefuseLoading(false);
          })
          .catch(() => setRefuseLoading(false));
      })
      .catch(erreur => {
        setRefuseLoading(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({ type: 'user/addRefresh', payload: reponse.data.refresh });
              dispatch({ type: 'user/addAccess', payload: reponse.data.access });
              handleRefuseInvitation(demandeId);
            });
          }
        }
      });
  };

  // Navigation functions
  const prefetchAdjacentParticipants = async () => {
    if (participantsNavigationIds.length === 0 || currentParticipantIndex < 0) {
      return;
    }

    const prevIndex = currentParticipantIndex - 1;
    const nextIndex = currentParticipantIndex + 1;

    // Prefetch previous
    if (prevIndex >= 0) {
      const prevId = participantsNavigationIds[prevIndex];
      if (!prefetchedParticipants[prevId]) {
        try {
          const response = await participantSelectRedux(accessToken, prevId, evenementSelected.id);
          dispatch(setPrefetchedParticipant({ id: prevId, data: response.data }));
        } catch (error) {
          console.log('Error prefetching previous participant:', error);
        }
      }
    }

    // Prefetch next
    if (nextIndex < participantsNavigationIds.length) {
      const nextId = participantsNavigationIds[nextIndex];
      if (!prefetchedParticipants[nextId]) {
        try {
          const response = await participantSelectRedux(accessToken, nextId, evenementSelected.id);
          dispatch(setPrefetchedParticipant({ id: nextId, data: response.data }));
        } catch (error) {
          console.log('Error prefetching next participant:', error);
        }
      }
    }
  };

  const handlePrevious = async () => {
    if (participantsNavigationIds.length === 0) {
      return;
    }

    setIsNavigating(true);
    try {
      // Check if we're at the start of the current page
      if (currentParticipantIndex <= 0) {
        // Need to load previous page
        const { currentPage } = participantsNavigationContext;
        if (currentPage <= 1) {
          // Already on first page, can't go back
          setIsNavigating(false);
          return;
        }

        // Load previous page
        const prevPage = currentPage - 1;
        const controller = new AbortController();
        const response = await participantsReduxPage(
          accessToken,
          evenementSelected.id,
          prevPage,
          '', // categories filter (you may need to pass the actual filter)
          false, // expert filter
          controller,
          '' // search term
        );

        if (response.data && response.data.results && response.data.results.length > 0) {
          // Update Redux with new page data
          dispatch(addParticipants(response.data));

          // Get the last participant of the previous page
          const newParticipants = response.data.results;
          const lastIndex = newParticipants.length - 1;
          const lastParticipant = newParticipants[lastIndex];

          // Update navigation context
          const participantIds = newParticipants.map(p => p.id);
          dispatch(
            setParticipantsNavigation({
              ids: participantIds,
              currentIndex: lastIndex,
              context: {
                currentPage: prevPage,
                totalPages: response.data.total_pages,
                totalCount: participantsNavigationContext.totalCount,
                pageSize: newParticipants.length,
              },
            })
          );

          // Load participant detail
          const detailResponse = await participantSelectRedux(
            accessToken,
            lastParticipant.id,
            evenementSelected.id
          );
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: detailResponse.data,
          });

          navigationPage(`/compteParticipant/${lastParticipant.id}/0`);
          window.scrollTo(0, 0);
        }
      } else {
        // Navigate within current page
        const prevIndex = currentParticipantIndex - 1;
        const prevId = participantsNavigationIds[prevIndex];

        // Check if we have prefetched data
        if (prefetchedParticipants[prevId]) {
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: prefetchedParticipants[prevId],
          });
          dispatch(updateCurrentParticipantIndex(prevIndex));
          navigationPage(`/compteParticipant/${prevId}/0`);
          window.scrollTo(0, 0);
        } else {
          const response = await participantSelectRedux(accessToken, prevId, evenementSelected.id);
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: response.data,
          });
          dispatch(updateCurrentParticipantIndex(prevIndex));
          navigationPage(`/compteParticipant/${prevId}/0`);
          window.scrollTo(0, 0);
        }
      }
    } catch (error) {
      console.log('Error navigating to previous:', error);
    } finally {
      setIsNavigating(false);
    }
  };

  const handleNext = async () => {
    if (participantsNavigationIds.length === 0) {
      return;
    }

    console.log('handleNext - currentIndex:', currentParticipantIndex);
    console.log('handleNext - participantsNavigationIds.length:', participantsNavigationIds.length);
    console.log('handleNext - navigationContext:', participantsNavigationContext);

    setIsNavigating(true);
    try {
      // Check if we're at the end of the current page
      if (currentParticipantIndex >= participantsNavigationIds.length - 1) {
        console.log('At end of page, loading next page...');
        // Need to load next page
        const { currentPage, totalPages } = participantsNavigationContext;
        console.log('currentPage:', currentPage, 'totalPages:', totalPages);

        if (currentPage >= totalPages) {
          // Already on last page, can't go forward
          console.log('Already on last page');
          setIsNavigating(false);
          return;
        }

        // Load next page
        const nextPage = currentPage + 1;
        console.log('Loading page:', nextPage);

        const controller = new AbortController();
        const response = await participantsReduxPage(
          accessToken,
          evenementSelected.id,
          nextPage,
          '', // categories filter (you may need to pass the actual filter)
          false, // expert filter
          controller,
          '' // search term
        );

        console.log('Next page loaded:', response.data);

        if (response.data && response.data.results && response.data.results.length > 0) {
          // Update Redux with new page data
          dispatch(addParticipants(response.data));

          // Get the first participant of the next page
          const newParticipants = response.data.results;
          const firstParticipant = newParticipants[0];

          console.log('First participant of next page:', firstParticipant);

          // Update navigation context
          const participantIds = newParticipants.map(p => p.id);
          dispatch(
            setParticipantsNavigation({
              ids: participantIds,
              currentIndex: 0,
              context: {
                currentPage: nextPage,
                totalPages: response.data.total_pages,
                totalCount: participantsNavigationContext.totalCount,
                pageSize: newParticipants.length,
              },
            })
          );

          // Load participant detail
          const detailResponse = await participantSelectRedux(
            accessToken,
            firstParticipant.id,
            evenementSelected.id
          );
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: detailResponse.data,
          });

          navigationPage(`/compteParticipant/${firstParticipant.id}/0`);
          window.scrollTo(0, 0);
        }
      } else {
        console.log('Navigating within current page');
        // Navigate within current page
        const nextIndex = currentParticipantIndex + 1;
        const nextId = participantsNavigationIds[nextIndex];

        // Check if we have prefetched data
        if (prefetchedParticipants[nextId]) {
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: prefetchedParticipants[nextId],
          });
          dispatch(updateCurrentParticipantIndex(nextIndex));
          navigationPage(`/compteParticipant/${nextId}/0`);
          window.scrollTo(0, 0);
        } else {
          const response = await participantSelectRedux(accessToken, nextId, evenementSelected.id);
          dispatch({
            type: 'evenements/addParticipantSelect',
            payload: response.data,
          });
          dispatch(updateCurrentParticipantIndex(nextIndex));
          navigationPage(`/compteParticipant/${nextId}/0`);
          window.scrollTo(0, 0);
        }
      }
    } catch (error) {
      console.log('Error navigating to next:', error);
    } finally {
      setIsNavigating(false);
    }
  };

  // Prefetch adjacent participants
  useEffect(() => {
    if (
      profilParticipant &&
      profilParticipant.id &&
      participantsNavigationIds.length > 0 &&
      currentParticipantIndex >= 0
    ) {
      prefetchAdjacentParticipants();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profilParticipant?.id, currentParticipantIndex]);

  // Clear prefetch cache when leaving
  useEffect(() => {
    return () => {
      if (participantsNavigationIds.length === 0) {
        dispatch(clearPrefetchedParticipants());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 19,
    height: 19,
    left: -5,
    // border: `2px solid ${theme.palette.background.paper}`,
  }));

  return (
    <div>
      <Container fluid>
        <Modal
          className="d-flex align-items-center"
          show={openEnvoyerDemande}
          onHide={() => setOpenEnvoyerDemande(false)}
          style={{ fontFamily: PoliceDefaut }}
        >
          <Modal.Header
            closeVariant="white"
            closeButton
            style={{ color: 'white', backgroundColor: '#134491' }}
          >
            <h4>Confirmation</h4>
          </Modal.Header>
          <form>
            <Modal.Body>
              Voulez-vous vraiment envoyer une demande ?
              <div className="d-flex justify-content-end mt-3">
                {circle2 ? (
                  <CircularProgress />
                ) : (
                  <Button className="btn-recup" onClick={() => handleEnvoiDemande()}>
                    Confirmer
                  </Button>
                )}

                <Button
                  className="btn-recup2 mx-2"
                  variant="secondary"
                  onClick={() => setOpenEnvoyerDemande(false)}
                >
                  Fermer
                </Button>
              </div>
            </Modal.Body>
          </form>
        </Modal>

        <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
        <Row>
          <Navigation
            button={param.contact === '0' ? true : false}
            titre={param.contact === '0' ? 'Participants' : 'Contacts'}
            photo={monProfil.photo_path}
            icone={
              param.contact === '0' ? pictos.participant_rond_icone : pictos.contact_rond_icone
            }
            evenement={param.contact === '0' ? evenementSelected.photo : ''}
            retour="dashboard"
            profile={false}
            selected={1}
            open={(!open).toString()}
            menus={true}
          />
        </Row>
        <Row className="p-0">
          <Chemin breadCrumbs={breadcrumbs_temp} />
        </Row>
        {participantsNavigationIds.length > 0 && param.contact === '0' && (
          <DetailNavigation
            currentIndex={currentParticipantIndex}
            totalCount={participantsNavigationIds.length}
            onPrevious={handlePrevious}
            onNext={handleNext}
            loading={isNavigating || loading}
            hideCounter={true}
            hasPreviousPage={participantsNavigationContext.currentPage > 1}
            hasNextPage={
              participantsNavigationContext.currentPage < participantsNavigationContext.totalPages
            }
          />
        )}
        {showLoading ? (
          <ProfileDetailSkeleton />
        ) : (
          <>
            <Row style={{}} className="infos-profil">
              <div className="container-gauche">
                <Container>
                  <Row className="" style={{ marginBottom: '6px' }}>
                    <Col xs={6} style={{ width: '', marginRight: '50px' }} className="p-0">
                      <Badge
                        style={{
                          margin: 'auto',
                          backgroundColor: '',
                          width: '120px',
                        }}
                        overlap="circular"
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'right',
                        }}
                        badgeContent={
                          param.contact === '0'
                            ? [
                                categories(
                                  categorieParticipant.photo,
                                  categorieParticipant.description,
                                  profilParticipant.is_expert,
                                  profilParticipant.is_speaker
                                ).map((item, index) => (
                                  <SmallAvatar
                                    key={index}
                                    title={item.title}
                                    className="p-0"
                                    src={item.icone}
                                    alt=""
                                    style={{
                                      width: '25px',
                                      height: '25px',
                                      backgroundColor: '  white',
                                    }}
                                  />
                                )),
                              ]
                            : 0
                        }
                      >
                        <Avatar
                          className="avatar-profil"
                          src={profilParticipant.photo_path}
                          style={{
                            width: '100px',
                            height: '100px',
                            backgroundColor: '',
                          }}
                        />
                        {/* <img src={profilParticipant.photo} alt="" style={{ width: '100px', height: '100px', backgroundColor: '' }} /> */}
                        {/* <Avatar onClick={handleShowPhoto} src={PROFIL_TEST} style={{ width: '100px', height: '100px', backgroundColor: '' }} /> */}
                      </Badge>
                    </Col>

                    {profilParticipant.pending_invitation_id ? (
                      <Col
                        className="p-0 d-flex align-items-center justify-content-end"
                        style={{ width: '', gap: '8px' }}
                      >
                        {refuseLoading ? (
                          <CircularProgress size={30} />
                        ) : (
                          <Button
                            onClick={() =>
                              handleRefuseInvitation(profilParticipant.pending_invitation_id)
                            }
                            className="p-0 px-3 py-1"
                            variant="outline-danger"
                            style={{
                              borderRadius: '50px',
                            }}
                          >
                            Refuser
                          </Button>
                        )}
                        {acceptLoading ? (
                          <CircularProgress size={30} />
                        ) : (
                          <Button
                            onClick={() =>
                              handleAcceptInvitation(profilParticipant.pending_invitation_id)
                            }
                            className="p-0 px-3 py-1"
                            style={{
                              borderRadius: '50px',
                              backgroundColor: '#134491',
                              color: 'white',
                              border: 'none',
                            }}
                          >
                            Accepter
                          </Button>
                        )}
                      </Col>
                    ) : profilParticipant.is_contact_status === 'pending' || pending === true ? (
                      <Col
                        className="p-0 d-flex align-items-center justify-content-end"
                        style={{ width: '' }}
                      >
                        <img src={pictos.demande_attente_icone} alt="" width={'35px'} />
                      </Col>
                    ) : profilParticipant.is_contact_status === 'invite' ? (
                      <Col
                        className="p-0 d-flex align-items-center justify-content-end"
                        style={{ width: '' }}
                      >
                        <img
                          onClick={() => ouvrirEnvoyer(profilParticipant.id)}
                          src={pictos.ajout_contact_icone}
                          alt=""
                          width={'35px'}
                          style={{ cursor: 'pointer' }}
                        />
                      </Col>
                    ) : profilParticipant.is_contact_status === 'accepted' ? (
                      <Col
                        className="p-0 d-flex align-items-center justify-content-end"
                        style={{ width: '' }}
                      >
                        {circle ? (
                          <CircularProgress />
                        ) : (
                          <Button
                            onClick={() =>
                              chatSelect(
                                chat,
                                dispatch,
                                navigationPage,
                                `/chat/${contactChat[0].conversation.id}/${contactChat[0].conversation.room}/0`,
                                accessToken,
                                setCircle
                              )
                            }
                            className="p-0 px-2 py-1"
                            style={{
                              borderRadius: '50px',
                              backgroundColor: '#134491',
                              color: '',
                              border: 'none',
                            }}
                          >
                            {'Message'}
                          </Button>
                        )}
                      </Col>
                    ) : null}

                    <Col xs={100} className="nom-profil1 mt-1">
                      <Row className="d-flex align-items-center">
                        <Col className="profil-nom p-0" style={{ fontWeight: 'bold' }}>
                          {formatName(profilParticipant.user.prenom, profilParticipant.user.nom)}
                        </Col>
                      </Row>
                      <Row className="">
                        <Col className="p-0" style={{}}>
                          {formatFonction(profilParticipant.fonction)}
                          <br />
                          {profilParticipant.raison_sociale === '' ||
                          profilParticipant.raison_sociale === null
                            ? !profilParticipant.from_structure
                              ? upperFirst(profilParticipant.organisation.nom)
                              : profilParticipant.organisation.adresse_organisation.ville
                            : upperFirst(profilParticipant.raison_sociale)}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="coordonnees-container" style={{ margin: '', textAlign: '' }}>
                    <Col className="">
                      <Row className="coordonnee-info">
                        {profilParticipant.is_contact_status !== 'accepted' ? null : (
                          <Col className="coordonnees-titre p-0">Coordonnées</Col>
                        )}
                      </Row>
                      {profilParticipant.parametres.filter(
                        item => item.parametre === 'TELEPHONE'
                      )[0].etat === true ? (
                        <>
                          <Row className="d-flex align-items-center">
                            {profilParticipant.coordonnes.telephone.telephone_fixe === null ||
                            profilParticipant.coordonnes.telephone.telephone_fixe === 'None' ? (
                              <></>
                            ) : (
                              <>
                                <Col className="icone p-0" sm="auto">
                                  <img src={pictos.tel_icone} alt="" />
                                </Col>
                                <Col className="p-0">
                                  {profilParticipant.coordonnes.telephone.telephone_fixe}
                                </Col>
                              </>
                            )}
                          </Row>
                          <Row className="d-flex align-items-center">
                            {profilParticipant.coordonnes.telephone.telephone_portable === null ||
                            profilParticipant.coordonnes.telephone.telephone_portable === 'None' ||
                            profilParticipant.coordonnes.telephone.telephone_portable ===
                              profilParticipant.coordonnes.telephone.telephone_fixe ? (
                              <></>
                            ) : (
                              <>
                                <Col className="icone mt-2 p-0" sm="auto">
                                  <img src={pictos.tel_icone} alt="" />
                                </Col>
                                <Col className="p-0">
                                  {profilParticipant.coordonnes.telephone.telephone_portable}
                                </Col>
                              </>
                            )}
                          </Row>
                        </>
                      ) : null}

                      {profilParticipant.parametres.filter(item => item.parametre === 'EMAIL')[0]
                        .etat === true ? (
                        profilParticipant.coordonnes.email === null ? null : (
                          <Row className="d-flex align-items-center">
                            <Col className="icone mt-2 p-0" sm="auto">
                              <img src={pictos.mail_icone} alt="" />
                            </Col>
                            <Col className="p-0">
                              <a
                                style={{
                                  textDecoration: 'none',
                                  color: '#134491',
                                }}
                                href={`mailto:${profilParticipant.coordonnes.email}`}
                              >
                                {profilParticipant.coordonnes.email}
                              </a>
                            </Col>
                          </Row>
                        )
                      ) : null}

                      <Row className="d-flex align-items-center">
                        <Col className="p-0">
                          {reseauSociaux(profilParticipant.reseausociaux).map((item, index) =>
                            item.url !== null && item.url !== 'null' && item.url !== undefined ? (
                              item.url !== '' ? (
                                <div
                                  key={index}
                                  className="icone mt-2"
                                  style={{
                                    display: 'inline-block',
                                    width: '35px',
                                  }}
                                >
                                  <NavLink to={`${item.url}`} target="_blank">
                                    <img src={item.logo} alt="" />
                                  </NavLink>
                                </div>
                              ) : null
                            ) : null
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col className="mt-2 p-0">
                          {profilParticipant.from_structure ? null : (
                            // <NavLink to={profilParticipant.organisation.site_web === '' ? 'https://google.com' : profilParticipant.organisation.site_web} target='_blank'>
                            <img
                              className="logo-organisation"
                              onClick={
                                param.contact === '1' ||
                                profilParticipant.organisation.id_exposant === ''
                                  ? () => ''
                                  : () =>
                                      partenaireSelect(profilParticipant.organisation.id_exposant)
                              }
                              src={profilParticipant.organisation.logo}
                              alt="logo"
                              style={{
                                margin: 'auto',
                                cursor:
                                  param.contact === '1' ||
                                  profilParticipant.organisation.id_exposant === ''
                                    ? 'default'
                                    : 'pointer',
                              }}
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="container-droite">
                <Container>
                  <Row className="profil-coordonnees mb-2" style={{}}>
                    <Row className="d-flex align-items-center justify-content-end pt-3">
                      <Col className="profil-nom nom-profil2 p-0" style={{ fontWeight: 'bold' }}>
                        {formatName(profilParticipant.user.prenom, profilParticipant.user.nom)}
                      </Col>
                    </Row>
                    <Row className="nom-profil2">
                      <Col>
                        <Row>
                          <Col className="p-0" style={{}}>
                            {formatFonction(profilParticipant.fonction)}
                          </Col>
                        </Row>
                        <Row>
                          <Col className="p-0" style={{}}>
                            {profilParticipant.raison_sociale === '' ||
                            profilParticipant.raison_sociale === null
                              ? !profilParticipant.from_structure
                                ? upperFirst(profilParticipant.organisation.nom)
                                : upperFirst(
                                    profilParticipant.organisation.adresse_organisation.ville.toLowerCase()
                                  )
                              : upperFirst(profilParticipant.raison_sociale.toLowerCase())}{' '}
                            <i style={{ opacity: '0' }}>.</i>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Row>
                  {profilParticipant.presentation === '' ||
                  profilParticipant.presentation === null ||
                  profilParticipant.presentation === undefined ? null : (
                    <Row className="coordonnee-info">
                      <Row className="coordonnees-titre-infos">
                        <Col className="coordonnees-titre p-0">Présentation</Col>
                      </Row>
                      <Row className="pb-0" style={{ textAlign: 'left' }}>
                        <Col
                          className="p-0"
                          style={{
                            wordBreak: 'break-word',
                            height: 'fit-content',
                          }}
                          dangerouslySetInnerHTML={{
                            __html: upperFirst(profilParticipant.presentation),
                          }}
                        ></Col>
                      </Row>
                    </Row>
                  )}

                  {profilParticipant.expertises.length ? (
                    <Row className="coordonnee-info">
                      <Row className="coordonnees-titre-infos">
                        <Col className="coordonnees-titre p-0">Expertises</Col>
                      </Row>

                      {profilParticipant.expertises.map((item, index) => (
                        <Row key={index}>
                          <Col sm="auto" className="list-profil p-0">
                            • {upperFirst(toLower(item))}
                          </Col>
                        </Row>
                      ))}
                    </Row>
                  ) : null}
                  {profilParticipant.centreinterets.length ? (
                    <Row className="coordonnee-info">
                      <Row className="coordonnees-titre-infos">
                        <Col className="coordonnees-titre p-0">Centres d'intêrets</Col>
                      </Row>

                      {profilParticipant.centreinterets.map((item, index) => (
                        <Row key={index} className="">
                          <Col className="p-0">• {upperFirst(toLower(item))}</Col>
                        </Row>
                      ))}
                    </Row>
                  ) : null}
                  {profilParticipant.intervetions.length ? (
                    <Row className="coordonnee-info">
                      <Row className="coordonnees-titre-infos d-flex align-items-center justify-content-between">
                        <Col className="coordonnees-titre p-0" sm="auto">
                          Interventions
                        </Col>
                        <Col sm="auto">
                          <Button
                            variant="link"
                            onClick={() => navigationPage('/programmes')}
                            style={{
                              color: '#134491',
                              textDecoration: 'none',
                              fontSize: '0.8rem',
                            }}
                          >
                            Accéder au programme
                          </Button>
                        </Col>
                      </Row>

                      {profilParticipant.intervetions.map((item2, index) => (
                        <Row
                          key={index}
                          className="intervention-item py-2 d-flex justify-content-start"
                          onClick={() => programSelect(accessToken, item2.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          <Col
                            sm="auto intervention-temp px-1"
                            style={{
                              width: 'fit-content',
                              height: 'fit-content',
                              backgroundColor: couleurTheme(item2.categorie),
                              color: 'white',
                              fontSize: '0.75rem',
                              borderRadius: '4px',
                              marginRight: '15px',
                            }}
                          >
                            {item2.heure_fin === '' || item2.heure_fin === undefined
                              ? formatTimeTo24h(item2.heure_deb)
                              : `${formatTimeTo24h(
                                  item2.heure_deb
                                )} - ${formatTimeTo24h(item2.heure_fin)}`}
                          </Col>
                          <Col
                            className="p-0"
                            style={{
                              color: couleurTheme(item2.categorie),
                              fontSize: '0.9rem',
                              fontWeight: '500',
                            }}
                          >
                            {upperFirst(toLower(item2.titre))}
                          </Col>
                        </Row>
                      ))}
                    </Row>
                  ) : null}
                  <Row className="coordonnee-info"></Row>
                </Container>
              </div>
            </Row>
          </>
        )}
      </Container>
      {/*
       */}
    </div>
  );
};

export default CompteParticipant;
